
const text = {
  hu: {
    title: 'Szem\u00e9lys\u00e9r\u00fcl\u00e9ses k\u00f6z\u00fati k\u00f6zleked\u00e9si balesetek',
    forward: 'Tov\u00e1bb',
    back: 'Vissza',
    goToMap: 'Tov\u00e1bb a t\u00e9rk\u00e9phez',
    logo: 'ksh_logo.svg',
    loading: 'Adatok bet\u00f6lt\u00e9se...',
    accidents: 'balesetek sz\u00e1ma',
    fatal: 'balesetben meghaltak sz\u00e1ma',
    methodology: 'M\u00f3dszertan',
    datasource: 'Adatforr\u00e1s: Orsz\u00e1gos Rend\u0151r-F\u0151kapit\u00e1nys\u00e1g',
    openingScene: `
      <p>2018-ban Magyarorsz\u00e1gon<p>
      <p style="font-size: 120%; font-weight: bold;text-align: center;">16 951</p>
      <p>szem\u00e9lys\u00e9r\u00fcl\u00e9ssel j\u00e1r\u00f3 k\u00f6z\u00fati k\u00f6zleked\u00e9si baleset volt.</p>
      <p>Az ut\u00f3bbi \u00e9vek adatai alapj\u00e1n a legt\u00f6bb baleset <b>p\u00e9ntekenk\u00e9nt</b> d\u00e9lut\u00e1n 4 \u00e9s 5 \u00f3ra k\u00f6z\u00f6tt, a legkevesebb vas\u00e1rnaponk\u00e9nt t\u00f6rt\u00e9nik. Az \u00e9v legvesz\u00e9lyesebb h\u00f3napjai a <b>j\u00falius</b> \u00e9s az <b>augusztus</b>.</p>
    `,
    sunAlcoholScene: `
      <p>16&nbsp;951 balesetb\u0151l 1&nbsp;442-t okoztak <b>ittasan</b> 2018-ban. Az ittasan okozott balesetek sz\u00e1ma h\u00e9tv\u00e9genk\u00e9nt megn\u0151.</p>
    `,
    timelineScene1: `
        <p>Egy hosszabb, cs\u00f6kken\u0151 tendenci\u00e1t mutat\u00f3 id\u0151szak ut\u00e1n 2012 \u00f3ta \u00fajra n\u0151tt a balesetek sz\u00e1ma. Ezt minden bizonnyal a gyarapod\u00f3 aut\u00f3forgalom is okozhatja.</p>
        <p>2018-ban m\u00e1r 12%-kal t\u00f6bb baleset t\u00f6rt\u00e9nt a hazai utakon, mint 2012-ben.</p>
        `,
    timelineScene2: `
        <p>2018-ban <b>633</b> f\u0151 halt meg balesetben, ami t\u00f6bb, mint Sz\u00e1nt\u00f3d l\u00e9leksz\u00e1ma.</p>
        `,
    redScene: `
      <p>Balesetek orsz\u00e1gszerte el\u0151fordulnak, de a t\u00e9rk\u00e9pen j\u00f3l l\u00e1that\u00f3 egyes \u00fatszakaszokon s\u0171r\u0171s\u00f6d\u00e9s\u00fck a <b>2015&ndash;2018 id\u0151szak</b> adatai alapj\u00e1n.</p>
    `,
    budapestScene: `
      <p>J\u00f3l l\u00e1tsz\u00f3dnak <b>Budapest</b> legforgalmasabb \u00fatszakaszai \u00e9s az azokon t\u00f6rt\u00e9nt balesetek.</p>
    `,
    top7Scene: `
    <p>A hal\u00e1los kimenetel\u0171 balesetek sz\u00e1ma alapj\u00e1n legink\u00e1bb az <b>52.</b>, <b>51.</b> \u00e9s az <b>M2</b> utak egy-egy szakasza szolg\u00e1l r\u00e1 a hal\u00e1l\u00fat megnevez\u00e9sre.</p>
    <p>A t\u00e9rk\u00e9pen az a h\u00e9t \u00fatszakasz l\u00e1tszik, ahol a legt\u00f6bb hal\u00e1los baleset t\u00f6rt\u00e9nt 2015&ndash;2018 k\u00f6z\u00f6tt.<p>
    `,
    closingScene: `
      <p>A 2018-ban meghalt 468 j\u00E1rm\u0171vezet\u0151 \u00E9s utas k\u00F6z\u00FCl 268-an (57%) nem haszn\u00E1lt\u00E1k a <b>biztons\u00E1gi \u00F6vet</b>. A s\u00FAlyos s\u00E9r\u00FCl\u00E9ssel j\u00E1r\u00F3 balesetek eset\u00E9ben ez az ar\u00E1ny rosszabb: a s\u00FAlyosan s\u00E9r\u00FCltek 62%-a nem volt bek\u00F6tve a baleset bek\u00F6vetkez\u00E9sekor.</p>
      <p>Ha m\u00E1r megt\u00F6rt\u00E9nt a baleset, a biztons\u00E1gi \u00F6v haszn\u00E1lata meg tudja akad\u00E1lyozni a s\u00FAlyos vagy hal\u00E1los s\u00E9r\u00FCl\u00E9st.</p>
      <p><b>K\u00e9rj\u00fck, vezessenek \u00f3vatosan!</b></p>`,
    mapHelp: `Eg\u00e9r g\u00f6rg\u0151: nagy\u00edt/kicsiny\u00edt. Eg\u00e9r bal gomb: mozgat. Ctrl + eg\u00e9r gomb: forgat.`,
    SEVERITY_2: 'hal\u00e1los s\u00e9r\u00fcl\u00e9s',
    SEVERITY_4: 's\u00falyos s\u00e9r\u00fcl\u00e9s',
    SEVERITY_8: 'k\u00f6nny\u0171 s\u00e9r\u00fcl\u00e9s',

    VEHICLE_1: 'motorker\u00e9kp\u00e1r',
    VEHICLE_2: 'szem\u00e9lyg\u00E9pkocsi',
    VEHICLE_3: 'aut\u00f3busz',
    VEHICLE_4: 'teherg\u00e9pkocsi',
    VEHICLE_5: 'ker\u00e9kp\u00e1r',
    VEHICLE_6: 'seg\u00e9dmotoros-ker\u00e9kp\u00e1r',
    VEHICLE_7: 'gyalogos',
    VEHICLE_8: 'egy\u00e9b j\u00e1rm\u0171',
    MONTH_01: 'január',
    MONTH_02: 'február',
    MONTH_03: 'március',
    MONTH_04: 'április',
    MONTH_05: 'május',
    MONTH_06: 'június',
    MONTH_07: 'július',
    MONTH_08: 'augusztus',
    MONTH_09: 'szeptember',
    MONTH_10: 'október',
    MONTH_11: 'november',
    MONTH_12: 'december',
    okozo: 'okozó',
    kimenetel: 'kimenetel',
    months: [
      'm\u00e1rc.', '\u00e1pr.', 'm\u00e1j.',
      'j\u00fan.', 'j\u00fal.', 'aug.',
      'szept.', 'okt.', 'nov.',
      'dec.', 'jan.', 'febr.'
    ],
    seasons: ['TAVASZ', 'NY\u00c1R', '\u0150SZ', 'T\u00c9L'],
    weekdays: ['H', 'K', 'SZE', 'CS', 'P', 'SZO', 'V'],
    road4: '4-es \u00fat',
    road44: '44-es \u00fat',
    road51: '51-es \u00fat',
    road52: '52-es \u00fat',
    road83: '83-as \u00fat',
    roadM2: 'M2',
    close: 'Bez\u00e1r',
    modalTextTitle: 'M\u00d3DSZERTANI MEGJEGYZ\u00c9SEK',
    modalText: `
<p><b>K\u00f6zleked\u00e9si baleset</b> fogalm\u00e1n &ndash; statisztikai szempontb\u00f3l &ndash; olyan v\u00e1ratlan, nem sz\u00e1nd\u00e9kosan el\u0151id\u00e9zett forgalmi esem\u00e9nyt \u00e9rt\u00fcnk, amelynek k\u00f6vetkezm\u00e9nyek\u00e9nt hal\u00e1leset, illetve szem\u00e9lys\u00e9r\u00fcl\u00e9s t\u00f6rt\u00e9nt, vagy anyagi k\u00e1r keletkezett.</p>
<p><b>Szem\u00e9lys\u00e9r\u00fcl\u00e9ses k\u00f6z\u00fati k\u00f6zleked\u00e9si baleset:</b> minden olyan k\u00f6z\u00faton vagy a k\u00f6zforgalom sz\u00e1m\u00e1ra megnyitott mag\u00e1n\u00faton t\u00f6rt\u00e9nt baleset, amelyben legal\u00e1bb egy mozg\u00f3 j\u00e1rm\u0171 r\u00e9szt vett, \u00e9s amelynek k\u00f6vetkezt\u00e9ben legal\u00e1bb egy szem\u00e9ly meghalt, vagy megs\u00e9r\u00fclt.</p>
<ol>
<li>A balesetek min\u0151s\u00edt\u00e9se kimenetel szerint:
	<ol type="a">
		<li><b>hal\u00e1los kimenetel\u0171</b> az a <b>baleset</b>, amelyn\u00e9l legal\u00e1bb egy szem\u00e9ly a baleset helysz\u00edn\u00e9n, illetve 30 napon bel\u00fcl meghal;</li>
		<li><b>s\u00falyos s\u00e9r\u00fcl\u00e9ses</b> az a <b>baleset</b>, amelyn\u00e9l legal\u00e1bb egy szem\u00e9ly s\u00falyosan, 8 napon t\u00fal gy\u00f3gyul\u00f3an megs\u00e9r\u00fclt, de hal\u00e1leset nem t\u00f6rt\u00e9nt;</li>
		<li><b>k\u00f6nny\u0171 s\u00e9r\u00fcl\u00e9ses</b> az a <b>baleset</b>, amelyn\u00e9l legal\u00e1bb egy szem\u00e9ly k\u00f6nnyen, 8 napon bel\u00fcl gy\u00f3gyul\u00f3an megs\u00e9r\u00fclt, de hal\u00e1leset \u00e9s s\u00falyos s\u00e9r\u00fcl\u00e9s nem t\u00f6rt\u00e9nt.</li>
	</ol>
</li>
<li>A szem\u00e9lys\u00e9r\u00fcl\u00e9sek min\u0151s\u00edt\u00e9se:
<ol type="a">
		<li><b>hal\u00e1los s\u00e9r\u00fcl\u00e9s:</b> olyan s\u00falyos s\u00e9r\u00fcl\u00e9s, amelyet valaki baleset sor\u00e1n szenved el, vagy annak k\u00f6vetkezt\u00e9ben a balesetet k\u00f6vet\u0151 30 napon bel\u00fcl elhal\u00e1lozik;</li>
		<li><b>s\u00falyos s\u00e9r\u00fcl\u00e9s:</b> olyan s\u00e9r\u00fcl\u00e9s, amelyet valaki baleset sor\u00e1n szenved el, \u00e9s amely
			<ul>
				<li>a s\u00e9r\u00fcl\u00e9st\u0151l sz\u00e1m\u00edtott h\u00e9t napon bel\u00fcl 48 \u00f3r\u00e1t meghalad\u00f3 k\u00f3rh\u00e1zi \u00e1pol\u00e1st tesz sz\u00fcks\u00e9gess\u00e9, vagy</li>
				<li>csontt\u00f6r\u00e9st okoz, kiv\u00e9ve az ujj-, l\u00e1bujj- \u00e9s orrt\u00f6r\u00e9st, vagy</li>
				<li>olyan v\u00e1gott sebekkel j\u00e1r, amelyek s\u00falyos v\u00e9rz\u00e9st vagy ideg-, izom-, illetve \u00edns\u00e9r\u00fcl\u00e9st okoznak, vagy</li>
				<li>bels\u0151 szervek s\u00e9r\u00fcl\u00e9s\u00e9t okozza, vagy</li>
				<li>m\u00e1sod- vagy harmadfok\u00fa \u00e9g\u00e9si s\u00e9r\u00fcl\u00e9seket, vagy a testfel\u00fclet t\u00f6bb mint 5%-\u00e1t \u00e9rint\u0151 \u00e9g\u00e9si s\u00e9r\u00fcl\u00e9st okoz;</li>
			</ul>
		</li>
		<li><b>k\u00f6nny\u0171 s\u00e9r\u00fcl\u00e9s:</b> olyan s\u00e9r\u00fcl\u00e9s, amelynek k\u00f6vetkezt\u00e9ben a s\u00e9r\u00fclt k\u00f3rh\u00e1zi kezel\u00e9sre nem szorul, kiv\u00e9ve a 24 \u00f3r\u00e1s megfigyel\u00e9st.</li>
	</ol>
</li>
<li>Baleset k\u00f6vetkezt\u00e9ben meghalt, megs\u00e9r\u00fclt szem\u00e9lyek:
<ol type="a">
		<li><b>meghalt szem\u00e9ly</b>, aki a baleset k\u00f6vetkezt\u00e9ben a baleset helysz\u00edn\u00e9n, illetve 30 napon bel\u00fcl elhunyt;</li>
		<li><b>s\u00falyosan megs\u00e9r\u00fclt szem\u00e9ly</b>, aki a baleset k\u00f6vetkezt\u00e9ben s\u00falyos s\u00e9r\u00fcl\u00e9st szenved el;</li>
		<li><b>k\u00f6nnyen megs\u00e9r\u00fclt szem\u00e9ly</b>, aki baleset k\u00f6vetkezt\u00e9ben k\u00f6nny\u0171 s\u00e9r\u00fcl\u00e9st szenved el.</li>
	</ol>


</li>
</ol>
<p><b>Ittasan okozott balesetekn\u00e9l</b> a balesetet okoz\u00F3 szem\u00E9ly szervezet\u00E9ben a szeszes ital fogyaszt\u00E1s\u00E1b\u00F3l sz\u00E1rmaz\u00F3 alkohol jelenl\u00E9t\u00E9t, illetve annak m\u00E9rt\u00E9k\u00E9t v\u00E9ralkohol-vizsg\u00E1lattal vagy hiteles l\u00E9galkoholm\u00E9r\u0151vel \u00E1llap\u00EDtj\u00E1k meg.</p>
<p><b>Jogi h\u00e1tt\u00e9r:</b> a 2016. \u00E9vi CLV. t\u00F6rv\u00E9ny a statisztik\u00E1r\u00F3l \u00E9s a 1992. \u00E9vi LXIII. t\u00F6rv\u00E9ny a szem\u00E9lyes adatok v\u00E9delm\u00E9r\u0151l \u00E9s a k\u00F6z\u00E9rdek\u0171 adatok nyilv\u00E1noss\u00E1gra hoz\u00E1s\u00E1r\u00F3l, valamint az Eur\u00F3pai Uni\u00F3 93/704/EK hat\u00E1rozata.</p>
<p><b>Az adatok forr\u00e1sa:</b> Az adatfelv\u00e9tel teljes k\u00f6r\u0171 azokra a balesetekre, amikor rend\u0151ri int\u00e9zked\u00e9s t\u00f6rt\u00e9nik. Az int\u00e9zked\u00e9s sor\u00e1n a szem\u00e9lys\u00e9r\u00fcl\u00e9ssel j\u00e1r\u00f3 balesetr\u0151l adatfelv\u00e9teli lapot t\u00f6ltenek ki. A baleseti helysz\u00ednel\u0151 rend\u0151ri szerv a kit\u00f6lt\u00f6tt adatlapot a baleset helye szerinti megyei RFK k\u00f6zleked\u00e9srend\u00e9szeti oszt\u00e1ly\u00e1nak (Budapesten a BRFK K\u00f6zleked\u00e9srend\u00e9szeti F\u0151oszt\u00e1ly\u00e1nak) k\u00fcldi meg, ahol az adatlapokat r\u00f6gz\u00edtik. A KSH fel\u00e9 a balesetek adatszolg\u00e1ltat\u00f3ja az ORFK.</p>`
  },
  en: {

  }
}

export function createText(lang) {
  return (key) => text[lang][key];
}